import axios from 'axios';
import { showLoader, hideLoader } from './loaderManager';

let interceptorsConfigured = false;

const setupGlobalLoading = () => {
  if (interceptorsConfigured) {
    return;
  }
  interceptorsConfigured = true;

  axios.interceptors.request.use(
    (config) => {
      showLoader();
      return config;
    },
    (error) => {
      hideLoader();
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      hideLoader();
      return response;
    },
    (error) => {
      hideLoader();
      return Promise.reject(error);
    }
  );

  if (typeof window !== 'undefined' && window.fetch && !window.fetch.__LOADER_WRAPPED__) {
    const originalFetch = window.fetch;
    const wrappedFetch = async (...args) => {
      showLoader();
      try {
        const response = await originalFetch(...args);
        return response;
      } catch (error) {
        throw error;
      } finally {
        hideLoader();
      }
    };
    wrappedFetch.__LOADER_WRAPPED__ = true;
    window.fetch = wrappedFetch;
  }
};

export default setupGlobalLoading;

